// 에이전트 PC의 "수집 폴더 미지정" 판정 (2026-08-09 대표 지시)
// 배경: agentStatus/{labId}.devices 중 수집 폴더가 하나도 없는 PC는 그 PC에서 CAD 작업을 해도
//       케이스가 영원히 올라오지 않는데, 화면에는 정상 연결(🟢)로만 보인다 = 조용한 실패.
//       (실측 2026-08-09 아이반랩: 5대 중 DESKTOP-I6PF04Q가 stmtFolderPaths [] · stmtFolderCount 0)
//
// 판정 규칙 — 배열이 "존재하고" 길이가 0인 경우만 경고한다.
//  · stmtFolderPaths 필드가 아예 없는 구버전 에이전트(0.8.x 등)는 값을 안 보내는 것뿐이므로 제외(오탐 방지).
//    실측: DESKTOP-8AG0M96(v0.8.2)은 stmtFolderPaths 필드 자체가 없고 stmtFolderCount는 1 → 경고 대상 아님.
//  · stmtFolderCount > 0 인데 paths가 비어 있는 경우(목록만 잘려 온 상황)도 제외 — 실제로는 지정돼 있다.
export function isMissingStmtFolder(device) {
    if (!device) return false;
    if (!Array.isArray(device.stmtFolderPaths)) return false;   // 구버전 = 미보고 → 판정 불가
    if (device.stmtFolderPaths.length > 0) return false;
    if (Number(device.stmtFolderCount) > 0) return false;       // 목록만 생략된 경우
    return true;
}

// 대표 승인 문구 (설정 PC 목록·제작 현황 배너가 같은 표현을 쓴다)
export const MISSING_STMT_TITLE = '수집 폴더 미지정 — 이 PC에서 작업한 케이스는 올라오지 않습니다';
export const MISSING_STMT_HELP = '이 PC의 덴클 프로그램을 열어 CAD 작업 폴더(예: exocad의 CAD-Data 폴더)를 수집 폴더로 지정해 주세요.';
